import axios from '@/libs/api.request'
export const AddRechargeActivity = data=> {
  return axios.request({
    url: '/print/recharge/activity',
    data,
    method: 'post'
  })
}

export const GetRechargeActivity = data =>{
  console.log(data)
    return axios.request({
        url: '/print/recharge/activity',
        params : data,
        method: 'get'
      })
}